import { render, staticRenderFns } from "./SectionNavigation.vue?vue&type=template&id=6b2dc659&"
import script from "./SectionNavigation.vue?vue&type=script&lang=js&"
export * from "./SectionNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2dc659')) {
      api.createRecord('6b2dc659', component.options)
    } else {
      api.reload('6b2dc659', component.options)
    }
    module.hot.accept("./SectionNavigation.vue?vue&type=template&id=6b2dc659&", function () {
      api.rerender('6b2dc659', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SectionNavigation.vue"
export default component.exports